import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetWarehouse(Ids: any) {
		return this.fetch('/DropdownList/GetWarehouse/', { workshopId: Ids });
	}

	async GetFullInventoryAdjustmentReport(parameter: any, columnsSeq: any, languageId: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/GetFullInventoryAdjustmentReport?${parameter}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, EXPORT_FILE_NAME);
	}
}


export const apiProvider = new SestavyApi();
